module.exports = __webpack_public_path__ + "img/chengdu.bdb8876a.jpg";